import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class CopyPayablesService extends ApiService {
  namespace = "copy-invoice";
  icon = "Documents";
  name = "Copy";
  favicon = "ReceiptsWithArrow";
  actionTitle = "Create Copy";
  window = 290;
  Width = 700;
  DOMAIN = DOMAIN.COPY_PAYABLES;
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  action = "action";
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;

  copySelector = [
    {
      key: DOMAIN.INVOICE,
      label: "Invoice",
    },
    {
      key: DOMAIN.ESTIMATE,
      label: "Estimates",
    },
    {
      key: DOMAIN.SALES_RECEIPTS,
      label: "Sales reciept",
    },
    {
      key: DOMAIN.CREDIT_MEMO,
      label: "Credit Memos",
    },
  ];
  constructor() {
    super("");
  }
}
